import React, { useCallback, useEffect, useState } from "react";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import CustomTable from "./../../Components/CustomTable";

import "./style.css";

import FormModal from "../../Components/FormModal";
import Header from "../../Components/Header";
import useSelect from "../../Hooks/useSelect";
import useToggle from "../../Hooks/useToggle";
import { useUpdateGuidelineMutation } from "../../Redux/Apis/Guidelines";
import { useCreatePushNotificationMutation, useDeletePushNotificationMutation, useGetPushNotificationsQuery, useResendPushNotificationMutation } from "../../Redux/Apis/PushNotification";
import { dateFormatter } from "../../Utils";
import useSearch from "../../Hooks/useSearch";
import usePagination from "../../Hooks/usePagination";
import { toast } from "react-toastify";

const sortValues = [
    {
        text: "Name",
        value: "fullName",
    },
    {
        text: "Email",
        value: "email",
    }
];

const perPageValues = [
    {
        text: "8",
        value: 8,
    },
    {
        text: "15",
        value: 15,
    },
    {
        text: "30",
        value: 30,
    }
];

const maleHeaders = [
    {
        key: "id",
        title: "S.No",
    },
    {
        key: "title",
        title: "Notification Title",
    },
    {
        key: "message",
        title: "Notification Message",
    },
    {
        key: "createdAt",
        title: "Date of Creation",
    },
    {
        key: "actions",
        title: "",
    },
];

const PushNotifications = () => {

    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
    const [inputValue, setInputValue] = useState('');
    const [selectedData, setSelectedData] = useState();

    const [formOpen, _, toggleForm] = useToggle()
    const [isEdit, setIsEdit, toggleEdit] = useToggle()
    const [isFilterOpen, setIsFilterOpen, toggleFilter] = useToggle()

    const [sortBy, setSortBy] = useState(sortValues[0].value);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");

    const [search, debouncedSearch, onSearch] = useSearch()
    const { page, perPage, onNext, onPrevious } = usePagination()
    const { data, isLoading, refetch, isFetching } = useGetPushNotificationsQuery({
        page,
        rowsPerPage: perPage,
        search: debouncedSearch,
        sortBy,
        from,
        to
    });
    const [updateGuideline, { isSuccess: isUpdated, isLoading: isUpdating }] = useUpdateGuidelineMutation();
    const [submitPushNotification, { isSuccess }] = useCreatePushNotificationMutation()
    const [deletePushNotification, { data: deletedData, isSuccess: isDeleted, isLoading: isDeleting }] = useDeletePushNotificationMutation()

    const [resend, { data: resentData, isSuccess: resentSuccess }] = useResendPushNotificationMutation()

    const { isAllSelected, totalSelected, onSelectAll, onSelectRow, isExists } = useSelect(data?.data)

    useEffect(() => {
        if (resentSuccess) {
            toast.success(resentData?.message)
        }
    }, [resentSuccess])

    useEffect(() => {
        if (isSuccess) {
            toggleForm()
            refetch()
        }
    }, [isSuccess])

    useEffect(() => {
        if (isUpdated) {
            toggleForm()
            refetch()
            setSelectedData()
            toggleEdit()
        }
    }, [isUpdated])

    useEffect(() => {
        if (isDeleted) {
            refetch()
            setSelectedData()
            setShowModal(false)
            setShowModal2(true)
        }
    }, [isDeleted])

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    useEffect(() => {
        document.title = 'The Turn At | Notifications';
    }, []);

    const onSubmit = useCallback((data) => {
        if (isEdit) {
            updateGuideline({ ...data, _id: selectedData?._id })
        } else {
            submitPushNotification(data)
        }
    }, [isEdit])

    const onDelete = useCallback(() => {
        deletePushNotification(selectedData?._id)
    }, [selectedData])

    const onToggle = useCallback(() => {
        if (isEdit) {
            toggleEdit()
            setSelectedData()
        }
        toggleForm()
    }, [isEdit, selectedData, formOpen])

    const onResend = useCallback((id) => {
        resend(id)
    }, [])

    return (
        <>
            <DashboardLayout>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="dashCard">
                                <Header
                                    title="Notifications"
                                    buttons={[{ label: "Add Notifications", onClick: toggleForm, variant: "primaryButton" }]}
                                    length={totalSelected}
                                    search={search}
                                    onSearch={onSearch}
                                    nofilters
                                />
                                <div className="row mb-3">
                                    {
                                        (isLoading || isFetching) ? <Loader /> :
                                            <div className="col-12">
                                                <CustomTable
                                                    headers={maleHeaders}
                                                    isFilterOpen={isFilterOpen}
                                                    dateFilter={false}
                                                    filterSort={false}
                                                    perPage={true}
                                                    filterSortValues={sortValues}
                                                    perPageValues={perPageValues}
                                                    filterSortValue={sortBy}
                                                    setFilterSortValue={setSortBy}
                                                    filterFrom={from}
                                                    setFilterFrom={setFrom}
                                                    filterTo={to}
                                                    setFilterTo={setTo}
                                                    itemsPerPage={itemsPerPage}
                                                    setItemsPerPage={setItemsPerPage}
                                                    length={data?.data?.length}
                                                    isAllSelected={isAllSelected}
                                                    onSelectAll={onSelectAll}
                                                    page={page}
                                                    rowsPerPage={perPage}
                                                    onNext={onNext}
                                                    onPrevious={onPrevious}
                                                    total={data?.total}
                                                >
                                                    <tbody>
                                                        {data?.data?.map((item, index) => (
                                                            <tr key={item._id}>
                                                                {/* <td><input type="checkbox" value={item._id} checked={isExists(item._id)} onClick={() => onSelectRow(item?._id)} /></td> */}
                                                                <td>{(index + 1) + ((currentPage - 1) * itemsPerPage)}</td>
                                                                <td>
                                                                    {item.title}
                                                                </td>
                                                                <td>
                                                                    {item.message}
                                                                </td>
                                                                <td>{dateFormatter(item?.createdAt)}</td>
                                                                <td className="d-flex justify-content-center align-items-center">
                                                                    <CustomButton variant="primaryButton" text="Resend" className="mx-1" onClick={() => onResend(item?._id)} />
                                                                    <CustomButton variant="dangerButton" text="Delete" className="mx-1" onClick={() => { setSelectedData(item), setShowModal(true) }} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </CustomTable>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <FormModal
                        title={`${isEdit ? "Edit" : "Add"} Notification`}
                        open={formOpen}
                        toggle={onToggle}
                        onSubmit={onSubmit}
                        inputs={[
                            {
                                id: "title", label: "Title", placeholder: "Enter Title", required: true, initialValue: isEdit ? selectedData?.title : ""
                            },
                            {
                                id: "message", label: "Message", placeholder: "Enter Message", required: true, initialValue: isEdit ? selectedData?.message : "", type: "textarea"
                            }
                        ]}
                    />
                    <CustomModal loading={isDeleting} show={showModal} close={() => { setShowModal(false) }} action={onDelete} heading='Are you sure you want to delete this notification?' />
                    <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading={deletedData?.message} />
                </div >
            </DashboardLayout >
        </>
    );
};

export default PushNotifications